// Low-level helpers for turning a canvas into an ESC/POS raster command.
// Layout lives in escpos-ticket.ts; this module owns the byte encoding only.

const GS = 0x1d;

/**
 * Pack RGBA pixels into a `GS v 0` raster-print command.
 * Pixels with alpha > 128 print black. Width must be a multiple of 8.
 */
export function packRaster(width: number, height: number, rgba: Uint8ClampedArray): Uint8Array {
  if (width % 8 !== 0) throw new Error(`raster width must be a multiple of 8, got ${width}`);
  const bytesPerRow = width >> 3;
  const bitmap = new Uint8Array(bytesPerRow * height);
  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      const a = rgba[(y * width + x) * 4 + 3];
      if (a > 128) {
        bitmap[y * bytesPerRow + (x >> 3)] |= 0x80 >> (x & 7);
      }
    }
  }
  const cmd = new Uint8Array(8 + bitmap.length);
  cmd[0] = GS;
  cmd[1] = 0x76;
  cmd[2] = 0x30;
  cmd[3] = 0; // mode = normal
  cmd[4] = bytesPerRow & 0xff;
  cmd[5] = (bytesPerRow >> 8) & 0xff;
  cmd[6] = height & 0xff;
  cmd[7] = (height >> 8) & 0xff;
  cmd.set(bitmap, 8);
  return cmd;
}

export function loadImage(url: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error(`Failed to load image: ${url}`));
    img.src = url;
  });
}
